import "@/assets/scss/fonts.scss";
import 'leaflet/dist/leaflet.css';
import Vue from 'vue';
import VueGtag from "vue-gtag";
import Vuex from 'vuex';
import router from './router';
import store from './store';
import vuetify from './plugins/vuetify';
import Interceptor from '@/interceptor';
import { UserPermissions, Roles, Actions } from '@/config/userPermissions';
import Notifications from 'vue-notification';
import { sendLogToBackend } from "@/helpers/logHandler";
import './registerServiceWorker';
import VuejsDialog from 'vuejs-dialog';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
// @ts-ignore
import VueMask from 'v-mask';
import VueMeta from 'vue-meta';

const App = () => import('./App.vue');

Vue.use(VueGtag, {
  pageTrackerTemplate(to: any) {
    return {
      page_title: 'Pikni page',
      page_path: to.path
    }
  },
  config: {
    id: "G-JCRCDPVBW3"
  }
}, router);

Vue.use(Vuex);
Vue.prototype.$eventBus = new Vue();
Vue.config.productionTip = false;
Interceptor.setup();
Vue.use(VueMask);

Vue.mixin({
  data: function () {
    return {
      roles: Roles, 
      actions: Actions
    }
  },
  methods: {
     can: (action:Actions) => {
      return UserPermissions.can(action)
    }
  }
});

Vue.use(Notifications);
Vue.use(VuejsDialog);
Vue.use(VueMeta);

if (process.env.NODE_ENV != 'development') {
  Vue.config.errorHandler = function (err, vm, info) {
    // handle error
    // `info` is a Vue-specific error info, e.g., which lifecycle hook
    // the error was found in. Only available in 2.2.0+
    console.log(`Error: ${err.toString()}\nInfo: ${info}`);

    sendLogToBackend(err, store);
  }
}

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');